import React, { useEffect, useState } from "react";
import { client } from "../config/prismic";

const Footer = () => {
  const [home, setHome] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await client.getByType("home");
        setHome(response.results[0]?.data);
      } catch (error) {
        console.error("Error fetching footer data:", error);
      }
    };
    fetchData();
  }, []);

  if (!home) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }

  return (
    <footer
      id="rs-footer"
      className="relative bg-slate-50 pt-20 overflow-hidden"
    >
      {/* Decorative Blur Backgrounds */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-pink/5 rounded-full blur-[120px] -z-0"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-purple-600/5 rounded-full blur-[120px] -z-0"></div>

      <div className="container mx-auto px-4 relative z-10 pb-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          {/* Contact Info Column */}
          <div className="lg:col-span-4 space-y-10">
            <div className="space-y-6">
              <a href="/" className="inline-block group">
                <img
                  src={home.logo2.url}
                  alt="Logo"
                  className="h-16 w-auto group-hover:scale-105 transition-transform duration-300"
                />
              </a>
              <p className="text-slate-600 text-sm leading-relaxed max-w-sm">
                2027 International Conference on Socio-Technical Ecosystems and
                Global Sustainability
              </p>
            </div>

            <div className="space-y-6">
              <div className="flex items-start gap-4 group">
                <div className="w-10 h-10 rounded-xl bg-pink/10 flex items-center justify-center text-pink group-hover:bg-pink group-hover:text-white transition-all duration-300">
                  <i className="bi bi-geo-alt"></i>
                </div>
                <div>
                  <span className="block text-pink font-bold text-[10px] uppercase tracking-widest mb-1">
                    Venue
                  </span>
                  <p className="text-slate-700 text-sm">
                    {home.location[0].text}
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 group">
                <div className="w-10 h-10 rounded-xl bg-pink/10 flex items-center justify-center text-pink group-hover:bg-pink group-hover:text-white transition-all duration-300">
                  <i className="bi bi-envelope-open"></i>
                </div>
                <div>
                  <span className="block text-pink font-bold text-[10px] uppercase tracking-widest mb-1">
                    Email Us
                  </span>
                  <p className="text-slate-700 text-sm hover:text-pink transition-colors cursor-pointer">
                    {home.email[0].text}
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 group">
                <div className="w-10 h-10 rounded-xl bg-pink/10 flex items-center justify-center text-pink group-hover:bg-pink group-hover:text-white transition-all duration-300">
                  <i className="bi bi-telephone"></i>
                </div>
                <div>
                  <span className="block text-pink font-bold text-[10px] uppercase tracking-widest mb-1">
                    Call Support
                  </span>
                  <p className="text-slate-700 text-sm">
                    {home.contact_number[0].text}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Map Column */}
          <div className="lg:col-span-8 w-full h-full min-h-[400px]">
            <div className="relative h-full group">
              <div className="absolute -inset-1 bg-gradient-to-r from-pink/20 to-purple-600/20 rounded-[2rem] blur-2xl opacity-20 group-hover:opacity-40 transition duration-700"></div>
              <div className="relative h-full bg-white border border-slate-200 rounded-[2rem] overflow-hidden shadow-[0_20px_50px_rgba(0,0,0,0.06)]">
                <iframe
                  title="Venue Map"
                  className="w-full h-full min-h-[400px] transition-all duration-700 filter grayscale-[0.2] contrast-[1.1]"
                  src={home.google_map_embedded_link[0].text}
                  style={{ border: "0" }}
                  allowFullScreen=""
                  loading="lazy"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright Bar */}
      <div className="border-t border-slate-200 bg-white py-6">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            <p className="text-slate-500 text-[11px] font-medium text-center md:text-left uppercase tracking-wider">
              &copy; {new Date().getFullYear()}{" "}
              <span className="text-slate-800 font-bold">
                {home.acroynm[0].text}
              </span>
              . All Rights Reserved.
            </p>
            <div className="flex items-center gap-6">
              <span className="text-slate-400 text-[9px] font-bold uppercase tracking-[0.2em] border border-slate-100 px-4 py-1.5 rounded-full">
                Sponsored by Microsoft CMT
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
